export const formatINR = (n, currency = "INR") => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  try {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: currency || "INR",
      maximumFractionDigits: 2,
    }).format(Number(n));
  } catch {
    return `₹${Number(n).toFixed(2)}`;
  }
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit"
    });
  } catch {
    return iso;
  }
};

export const formatDateShort = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
};

export const statusBadgeClass = (s) => {
  const m = (s || "").toLowerCase();
  if (["paid", "captured", "success"].includes(m)) return "ldc-badge ldc-badge-paid";
  if (["pending", "authorized", "created"].includes(m)) return "ldc-badge ldc-badge-pending";
  if (["failed", "cancelled", "expired"].includes(m)) return "ldc-badge ldc-badge-failed";
  if (["refunded"].includes(m)) return "ldc-badge ldc-badge-refunded";
  if (["partially_refunded", "partially paid", "partially_paid"].includes(m)) return "ldc-badge ldc-badge-partial";
  return "ldc-badge";
};
